export function noOptionsMessage() {
  return 'Žiadne možnosti';
}

export function loadingMessage() {
  return 'Načítavam...';
}
